import { navigate } from 'gatsby';

import { useIsPlayer } from '.';


export default function useRedirectUser(to) {
  if (useIsPlayer() && to) {
    navigate(to);
  }
}